import { render, staticRenderFns } from "./Pets.vue?vue&type=template&id=2136f1ac&scoped=true"
import script from "./Pets.vue?vue&type=script&lang=js"
export * from "./Pets.vue?vue&type=script&lang=js"
import style0 from "./Pets.vue?vue&type=style&index=0&id=2136f1ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2136f1ac",
  null
  
)

export default component.exports